// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* From https://stackoverflow.com/questions/17029384/rotating-a-svg-with-css-animation/17031363 */

.cocalc-spin {
  animation-name: ckw;
  animation-duration: 20s;
  animation-iteration-count: infinite;
  transform-origin: 50% 50%;
  display: inline-block;
}
@keyframes ckw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cocalc-fade-in {
  opacity: 0;
  animation-duration: 4s;
  animation-name: cocalc-fadein;
}

@keyframes cocalc-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./dist-ts/src/startup-banner.css"],"names":[],"mappings":"AAAA,iGAAiG;;AAEjG;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* From https://stackoverflow.com/questions/17029384/rotating-a-svg-with-css-animation/17031363 */\n\n.cocalc-spin {\n  animation-name: ckw;\n  animation-duration: 20s;\n  animation-iteration-count: infinite;\n  transform-origin: 50% 50%;\n  display: inline-block;\n}\n@keyframes ckw {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.cocalc-fade-in {\n  opacity: 0;\n  animation-duration: 4s;\n  animation-name: cocalc-fadein;\n}\n\n@keyframes cocalc-fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
